import React, { useCallback } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useCurrent, useFetch } from '../hooks';
import TicketInfo from '../components/tickets/TicketInfo';
import TicketDetailsList from '../components/tickets/TicketDetailsList';
import CreateTicketDetails from '../components/tickets/CreateTicketDetails';
import { normalizeSupportSettings } from '../constants/ticket';
import { CardHeaderWithActions, MwButton } from '../components/ui';
import { useTranslation } from 'react-i18next';

const TicketsShow = () => {
    const [t] = useTranslation('global');
    const navigate = useNavigate();
    const params = useParams();
    const [searchParams] = useSearchParams();
    const { userId, currentLangId } = useCurrent();
    const id = params.id;

    const { data: ticketResult, loading: ticketLoading, refreshHandler } = useFetch(`${process.env.REACT_APP_SUPPORT_API_BASE_URL}/${id}`);
    const { data: supportSettingsResult } = useFetch(`${process.env.REACT_APP_SUPPORT_API_BASE_URL}/settings`);
    const { data: statusesResult } = useFetch(`${process.env.REACT_APP_SUPPORT_API_BASE_URL}/statuses`);
    const ticket = ticketResult?.data;
    const supportSettingsBase = normalizeSupportSettings(supportSettingsResult);
    const supportSettings = {
        ...supportSettingsBase,
        statuses: normalizeSupportSettings({ data: { statuses: statusesResult?.data || [] } }).statuses
    };

    // تذكرة تبع مشروع الشركة ومش بتاعة المستخدم: بيشوفها بس من غير رد أو أي إجراء.
    const fromProjectId = searchParams.get('project') || '';
    const isOwnTicket = Boolean(userId && ticket && (String(ticket.createdBy || '') === String(userId) || String(ticket.customerId || '') === String(userId)));
    const isReadOnly = Boolean(ticket?.projectId) && !isOwnTicket;
    const isAr = currentLangId !== 'en';

    const callBackOnCreated = useCallback(() => {
        refreshHandler()
    }, [refreshHandler])
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <CardHeaderWithActions title={t('support.tickets.ticketDetailsTitle')}>
                {(fromProjectId || ticket?.projectId) && (
                    <MwButton type='secondary' onClick={() => navigate(`/${params.tenant}/projects/show/${fromProjectId || ticket?.projectId}`)}>
                        {isAr ? `المشروع #${ticket?.projectNumber ?? ''}` : `Project #${ticket?.projectNumber ?? ''}`}
                    </MwButton>
                )}
                <MwButton type='secondary' onClick={() => navigate(`/${params.tenant}/tickets`)}>
                    {t('support.tickets.manageTickets')}
                </MwButton>
            </CardHeaderWithActions>
            {isReadOnly && (
                <div style={{ padding: '10px 14px', borderRadius: 12, background: '#f1f5f9', color: '#475569', fontSize: 12, fontWeight: 700 }}>
                    {isAr ? 'هذه التذكرة تابعة لمشروع شركتك — متاحة للعرض فقط.' : 'This ticket belongs to your company project — view only.'}
                </div>
            )}
            <TicketInfo loading={ticketLoading} item={ticket} supportSettings={supportSettings} onRefresh={refreshHandler} />
            {ticket && !isReadOnly && <CreateTicketDetails ticketID={ticket?._id} callBackOnCreated={callBackOnCreated} />}
            {ticket && <TicketDetailsList loading={ticketLoading} data={ticket?.details} ticket={ticket} onRefresh={refreshHandler} />}
        </div>
    )
}

export default TicketsShow
